// extracted by mini-css-extract-plugin
export default {"container":"UnsupportedDocumentBanner_container__rfp-f"};